<template>
  <div class="homepage">
    <Header>
      <div slot="nav">
        <span class="active" title="加密文件" @click="$router.push('/homepage')">主页</span>
        <span class title="查看7天内加密文件" @click="$router.push('/record')">加密记录</span>
      </div>
      <div slot="info">
        <div class="date left">
          <span>{{ myDate }}</span>
        </div>
        <div class="user left">
          <span
            class
            @click="showDepartment = !showDepartment"
            :title="userDepartment"
          >你好! {{userName}}</span>
        </div>
        <div class="help left">
          <span @click="toHelp">
            <img src="@/assets/help.svg" alt> 帮助
          </span>
        </div>
        <div class="login left">
          <span title="退出登录" @click="logout">
            <img src="@/assets/sign_out.svg" alt> 退出
          </span>
        </div>
      </div>
    </Header>
    <main>
      <div class="table-container">
        <div class="title">文档列表</div>
        <div class="table">
          <el-table ref="table"
            :data="tableData"
            border
            :height="windowAutoHeight"
            size="medium"            
            empty-text="用户每次只能加密10个文档，每个文档不能大于10M"
          >
            <el-table-column prop="fileName" label="加密文档" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="授权对象" width="380" show-overflow-tooltip></el-table-column>
            <el-table-column prop="encodeDate" label="加密时间" width="180"></el-table-column>
            <el-table-column prop="result" label="加密结果" width="180"></el-table-column>
          </el-table>
        </div>        
        <div class="operation">          
          <el-upload
            :action="postFileUrl"
            :headers="uploadHeader"
            multiple
            ref="myUpload"
            :limit="10"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :on-success="handleUploadSuccess"
            :on-change="countFiles"
            :on-error="handleUploadFailed"
            :on-exceed="handleExceed"
            :accept="accept"
          >
            <button class="select-file">选择目标文件</button>
          </el-upload>          
        </div>
      </div>
    </main>
    <el-dialog
      title="选择授权对象"
      width="956px"
      center
      :close-on-click-modal="false"
      :before-close="handleEncodeClose"
      :visible.sync="dialogEncodeVisible"
      v-if="resetComponent"
    >
      <div class="encode-dialog-container">
        <div class="encode-way">
          <span>加密方式：</span>
          <el-radio v-model="encodeWay" label="useTemplate" @change="changeEncodeWay">使用模板授权</el-radio>
          <el-radio v-model="encodeWay" label="useCustom" @change="changeEncodeWay">自定义加密</el-radio>
        </div>
        <div class="panel">
          <div class="use-template" v-show="encodeWay === 'useTemplate'">
            <el-table
              :ref="encodeSingleTable"
              :data="encodeTemplate"
              border
              size="medium"
              height="427"
              :highlight-current-row="highlight"
              @current-change="handleSingleChange"
            >
              <el-table-column prop="Name" label="模板名称" width="250" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column
                prop="Description"
                label="描述"
                min-width="350"
                :show-overflow-tooltip="true"
              ></el-table-column>
            </el-table>
            <div class="use-template-foot clearfix">
              <div class="right">
                <el-button size="small" @click="cancelEncode">取消</el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="handleEncode"
                  :disabled="norClick"
                >下一步</el-button>
              </div>
            </div>
          </div>
          <div class="use-custom" v-show="encodeWay === 'useCustom'">
            <div class="custom-way-container">
              <div class="left company-structure">
                <el-tabs type="border-card" @tab-click="tabclick">
                  <el-tab-pane v-for="(item) in tabs" 
                  :key="item.name" 
                  :label="item.title"
                  :disabled="tableDisabled">
                    <div class="content">
                      <el-input
                        size="small"
                        placeholder="请输入检索内容，按回车键开始检索内容"
                        v-model="searchId[item.name]"
                        @input="handleSearchData"
                        @keyup.enter.native="handleSearchDataKeyDown"
                        class="search"
                      >
                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                      </el-input>
                      <el-tree
                        v-show="searchId[item.name] === ''"
                        :ref="'companyStructrue' + item.name"
                        :load="loadNode"
                        :props="myTreeProps"
                        :highlight-current-row="highlight"
                        lazy
                        :check-on-click-node="true"
                        @check-change="handleCheckChange_companyStructrue"                      
                      >
                        <span class="custom-tree-node" slot-scope="{node}">
                          <span @dblclick="addPerson" class="node">{{node.label}}</span>
                        </span>
                      </el-tree>
                      <el-tree
                        :ref="'searchStructrue' + item.name"
                        v-show="searchId[item.name] !== ''"
                        :data="searchData[item.name]"
                        :props="myTreeProps"
                        :highlight-current-row="highlight"
                        :check-on-click-node="true"
                        @check-change="handleCheckChange_searchStructrue"
                        :empty-text="emptyText"
                      >
                        <span class="custom-tree-node" slot-scope="{node}">
                          <span @dblclick="addPerson" class="node">{{node.label}}</span>
                        </span>                      
                      </el-tree>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="自定义人员组">
                    <div class="content">
                      <div class="list custom-list">
                        <el-tree
                          ref="customStructrue"                          
                          :props="myTreeProps"
                          :highlight-current="true"
                          :data="customStructrueData"
                          :check-on-click-node="true"
                          @check-change="handleCheckChange_customStructrue"
                        ></el-tree>
                      </div>
                      <div class="custom-operation">
                        <el-button size="small" @click="createGroup">添加组</el-button>
                        <el-button size="small" @click="editGroup">更新组</el-button>
                        <el-button size="small" @click="deleteGroup">删除组</el-button>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="left add-person">
                <div class="content">
                  <div class="add-right" @click="addPerson" title="添加人员">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="add-left" @click="deletePerson" title="移除人员">
                    <i class="el-icon-arrow-left"></i>
                  </div>
                </div>
              </div>
              <div class="right permission">
                <div class="title clearfix">
                  <span title="注：添加到 '文档读者' 的用户默认拥有读取文档内容的权限" class="left">文档读者</span>
                  <span class="right" :class="persons.length > 8 ? 'ellipsis' : ''">
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAllPersons"
                      @change="handleCheckAllChange"
                    >允许修改文档内容</el-checkbox>
                  </span>
                </div>
                <div class="content">
                  <div
                    class="person clearfix"
                    v-for="(person, index) in persons"
                    :key="index"
                    :class="activeClass === index ? 'active' : ''"
                  >
                    <div
                      class="left name"
                      @click="selectedFileReader(index)"
                      @dblclick="deletePersonWithDB(index)"
                    >
                      <div
                        class="block-element name-path"
                        :title="person.path.split('_').reverse().join('>')"
                      >{{person.path.split('_').reverse().join('>')}}</div>
                    </div>
                    <div class="right">
                      <el-checkbox-group
                        v-model="checkedPersons"
                        @change="handleCheckedAllowChange"
                      >
                        <el-checkbox :label="person" class="block-element">允许修改文档内容</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="quanxian clearfix">
                <el-checkbox v-model="allowPrint">允许打印</el-checkbox>
                <el-checkbox v-show="IsShow===true" v-model="allowCopy">允许复制</el-checkbox>
                <el-checkbox v-model="allowSetIndate">
                  限定文档过期时间：
                  <el-date-picker
                    type="date"
                    v-model="indate"
                    size="small"
                    :disabled="allowSetIndate === false"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-checkbox>
                <el-checkbox v-model="allowContactAuthor">允许读者联系文档所有者</el-checkbox>
                <transition name="fade">
                  <div class="contact clearfix" v-show="allowContactAuthor === true">
                    <el-radio v-model="contactWay" label="1">
                      KK:
                      <input type="text" placeholder="请输入QQ号码" v-model="kk" disabled>
                    </el-radio>
                    <el-radio v-model="contactWay" label="2">
                      电话：
                      <input
                        type="number"
                        placeholder="请输入电话或手机"
                        v-model="phone"
                        :disabled="contactWay !== '2'"
                      >
                    </el-radio>
                  </div>
                </transition>
              </div>
              <div class="clearfix">
                <div class="right">
                  <el-button size="small" @click="cancelEncode">取消</el-button>
                  <el-button
                    type="primary"
                    size="small"
                    @click="handleEncode"
                    :disabled="norClick"
                  >下一步</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogText"
      width="956px"
      center
      :close-on-click-modal="false"
      :visible.sync="dialogPersonVisible"
      :before-close="handlePersonClose"
      v-if="resetComponent"
    >
      <div class="person-dialog-container">
        <div class="left company-structure">
          <div class="search">
            <span>名称:</span>
            <el-input
              size="small"
              placeholder="请输入检索内容，按回车键开始检索内容"
              v-model="searchIdForAddGroup"
              @input="handleSearchData2"
              @keyup.enter.native="handleSearchDataKeyDown2"
              class="input"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="content">
            <el-tree
              ref="newGroupTreeSource"
              v-show="searchIdForAddGroup === ''"
              :load="loadNode2"
              :props="myTreeProps"
              :highlight-current="true"
              lazy
              :check-on-click-node="true"
              @check-change="handleCheckChangeForGroup"
            >
              <span class="custom-tree-node" slot-scope="{node}">
                <span @dblclick="addPersonToGroup" class="node">{{node.label}}</span>
              </span>
            </el-tree>
            <el-tree
              ref="searchStructrue"
              v-show="searchIdForAddGroup !== ''"
              :data="searchData[this.tabsCount]"
              :props="myTreeProps"
              :highlight-current-row="highlight"
              :check-on-click-node="true"
              @check-change="handleCheckChange_searchStructrue"
              :empty-text="emptyText2"
            >
              <span class="custom-tree-node" slot-scope="{node}">
                <span @dblclick="addPersonToGroup" class="node">{{node.label}}</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="left add-person">
          <div class="content">
            <div class="add-right" @click="addPersonToGroup">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="add-left" @click="deletePersonFromGroup">
              <i class="el-icon-arrow-left"></i>
            </div>
          </div>
        </div>
        <div class="left group">
          <div class="group-name">
            <span>自定义组名:</span>
            <input type="text" v-model="groupName" class="el-input__inner">
          </div>
          <div class="content">
            <el-table
              :data="newGroupData"
              height="420"
              size="medium"
              empty-text=" "
              style="width: 100%"
              :highlight-current-row="true"
              :row-class-name="tableRowClassName"
              @row-dblclick="deleteGroupPerson"
              @current-change="handleSelectionChange"
            >
              <el-table-column prop="label" label="姓名" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="department" label="部门" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <el-button size="small" @click="handlePersonClose">取消</el-button>
          <el-button type="primary" size="small" @click="handleGroup">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import Header from "@/components/Header";
import include from "@/common/utils/include";
import indexWith from "@/common/utils/indexWith";

import {
  getDepartmentNode,
  getTemplates,
  encodeForTemplate,
  encodeForCustom,
  getSearchData,
  getCopyRight,
  getDefaultOU,
  getTabsName,
  baseUrl
} from "@/common/http/server";
import { getStorage, setStorage } from "@/common/utils/localStorage";
import { format } from "@/common/utils/date";
import {
  Table,
  TableColumn,
  Dialog,
  Button,
  Radio,
  Tabs,
  TabPane,
  Checkbox,
  DatePicker,
  Input,
  Upload,
  Collapse,
  CollapseItem,
  Popover,
  Loading,
  Tree,
  CheckboxGroup,
  Message
} from "element-ui";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Radio);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatePicker);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tree);
Vue.component(Message.name, Message);

export default {
  name: "homepage",
  components: { Header },
  data() {
    return {
      userName: "",
      userDepartment: "",
      //userEmail: "",
      userCn: "",
      myDate: new Date().toLocaleString(),
      tableData: [], // 当前页展示数据      
      dialogEncodeVisible: false,
      dialogPersonVisible: false,
      resetComponent: true, //用于初始化弹框
      loadingInstance: null,
      selectAmount: 0,
      uploadAmount: 0,
      encodeTemplate: [], // 加密模板
      encodeWay: "useTemplate",
      encodeSingleTable: null,
      highlight: true,
      uploadFiles: [],
      uploadFilesNew: [],
      searchId: [],
      searchData: [[]],
      currentTreePath: "",
      myTreeData: [],
      myTreeProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf"
      },
      labelCheckedPerson: {},
      isIndeterminate: false,
      checkAllPersons: false,
      persons: [],
      checkedPersons: [],
      selectedFileReaderIndex: -1,
      selectedFileReaderId: "",
      activeClass: -1,
      indate: new Date(),
      phone: "",
      kk: "kk联系",
      newGroupData: [],
      singleSelection: {},
      allowPrint: false,
      allowCopy: false,
      allowSetIndate: false,
      allowContactAuthor: false,
      contactWay: "1",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      groupName: "",
      customStructrueData: [],
      dialogText: "添加自定义人员组",
      createOrEdit: "",
      searchIdForAddGroup: "",
      norClick: false,      
      IsShow: false,
      defaultOU: [],
      tabs: [],
      tabsCount: 0,
      windowAutoHeight: window.innerHeight - 210,
      tableIndex: 0,
      nodeIndex: 0,
      tableDisabled: false,
      resultData:[[]],
      emptyText: "暂无数据",
      emptyText2: "暂无数据",
      accept: ".docx,.xlsx,.xls,.pptx,.pdf,.doc,.ppt,.txt"
    };
  },
  created() {
    this.loadCustom();
    this.getUserInfo();
    this.upDateTableData();
    this.loadEncodeTemplate();
    this.loadCopyRightInfo();
    this.loadDefaultOU(0);
    this.loadTabs();
  },
  mounted() {
    this.myDate = format(new Date());
    let _this = this
    this.timer = setInterval(function () {
      _this.myDate = format(new Date());
    }, 1000); 

    window.onresize = function windowResize () {
      _this.windowAutoHeight = window.innerHeight - 210;
    }
  },
  computed: {
    uploadHeader() {
      return {
        user: this.userCn,
        Authorization :'BasicAuth ' + getStorage('ticket')
      };
    },
    postFileUrl() {
      return baseUrl + "Upload/PostFile";
    }    
  },
  methods: {
    tabclick(tab, event) {   
      let id = event.target.getAttribute('id');
      this.tableIndex=parseInt(id.substr(id.indexOf('-')+1));      
    },
    getUserInfo() {
      const user = getStorage("user");
      this.userName = user.displayname;
      //this.userEmail = user.mail;
      this.userDepartment = user.departmentname;
      this.userCn = user.cn;
    },
    toHelp() {
      let linkTo = this.$router.resolve({ path: "/help" });
      window.open(linkTo.href, "_blank");
    },
    logout() {
      setStorage("user", {});
      setStorage("uploadList", []);
      setStorage("ticket", false);
      this.$router.push("/login");
    },
    handleBeforeUpload(file) {
      let ext = file.name.substring(file.name.lastIndexOf('.')+1);

      if((this.accept+",").indexOf(ext) < 0){        
        Message.error({
          message: `不支持 ${ext} 文件类型上传`
        });
        this.uploaderInit();
        return false;
      }
      let maxLimitSize = 1024 * 1024 * 10;
      let isLimit = file.size < maxLimitSize;
      this.loadingInstance = Loading.service({
        text: "正在加载"
      });
      if (isLimit) {
        // this.loadingInstance = Loading.service({
        //   text: '上传中'
        // })
      } else {
        this.loadingInstance.close();
        Message.error({
          message: `文件 ${file.name} 大于10M，无法上传`
        });
        this.uploaderInit();
      }
      
      return isLimit;
    },
    handleUploadSuccess(res, file, fileList) {
      let resJson = JSON.parse(res);
      let fileName = file.name;
      let fileNameNew = resJson.Filenamenew;
      this.uploadFiles.push(fileName);
      this.uploadFilesNew.push(fileNameNew);
      this.uploadAmount++;
      // 初始化加密选项
      this.initEncode();
      setTimeout(() => {
        if (2 * this.uploadAmount === this.selectAmount) {
          if(this.loadingInstance) {
            this.loadingInstance.close();
          }            
          this.dialogEncodeVisible = true;
        }
      }, 0);
    },
    handleUploadFailed(res, file, fileList) {
      this.uploaderInit();
    },
    handleExceed(file) {
      if(file.length >= 10){
        Message.error({
          message: "每次上传文件个数不能超过10个"
        });        
      }
    },
    uploaderInit() {
      /**
       *  上传组件初始化
       *  uploadAmount 上传成功的文件数量统计清零
       *  selectAmount 选定的文件数量统计清零
       *  uploadFiles 选定的文件名记录统计清零
       *  上传组件的文件缓存清除
       * */
      this.uploadAmount = 0;
      this.selectAmount = 0;
      this.uploadFiles.length = 0;
      this.uploadFilesNew.length = 0;
      this.$refs.myUpload.clearFiles();
    },
    countFiles(file, fileList) {
      // 利用el-upload组件的on-change钩子函数，该函数在文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
      // 即调用次数是选择文件数量 * 2，利用这个特性统计每次上传操作选定的文件数量。
      this.selectAmount++;
    },
    handleEncodeClose() {
      this.uploaderInit();
      this.dialogEncodeVisible = false;
    },
    // 选择加密模板或自定义加密
    changeEncodeWay(val) {
      this.encodeWay = val;

      if (this.encodeWay === "useTemplate") {
        this.highlight = false;
      }
      if (this.encodeWay === "useCustom") {
        this.encodeSingleTable = "";
        this.highlight = false;
        this.labelCheckedPerson = {};
        this.persons = [];
        this.checkedPersons = [];
        this.allowPrint = false;
        this.allowCopy = false;
        this.allowSetIndate = false;
        this.allowContactAuthor = false;
        this.phone = "";
      }
    },
    handleSingleChange(val) {
      this.highlight = true;
      this.encodeSingleTable = val;
    },
    uploadList(data, authorizationPersons) {
      // 文档列表
      let arr = getStorage("uploadList") || [];

      // 加密记录
      let userId = getStorage("user").cn;
      let recordArr = getStorage(userId) || [];
    
      let date =format(new Date());
      data.forEach(obj => {
        let temp = {
          fileName: obj.fileName,
          encodeDate: date,
          result: obj.yesorno == "true" ? "已加密" : "未加密",
          name: authorizationPersons.join(",")
        };
        arr.push(temp);
        recordArr.push(temp);
      });

      setStorage("uploadList", arr);
      setStorage(userId, recordArr);
    },
    upDateTableData() {
      let arr = getStorage("uploadList") || [];
      this.tableData = arr;
    },
    getAuthorizationPersons() {
      let arr = this.persons;
      let result = [];
      arr.forEach(item => {
        result.push(item.path.split("_")[0].replace("CN=", ""));
      });
      return result;
    },
    cancelEncode() {
      this.dialogEncodeVisible = false;
      this.uploaderInit();
    },
    async handleEncode() {      
      let result; //加密成功过后得到的文件名数组 [{fileName: xxx}]

      if (this.encodeWay === "useCustom") {
        if (!this.persons.length) {
          Message.error({
            message: "文档读者不能为空"
          });
          return;
        }
        let requestData = {
          data: this.encodeForCustomData()
        };
        let header = {
          user: this.userCn,
          responseType: "blob"
        };
        this.loadingInstance = Loading.service({
          text: "正在加密"
        });
        // 防止重复点击提交
        this.norClick = true;
        result = await encodeForCustom(requestData, header);
        this.uploaderInit();
        this.uploadList(result.data, this.getAuthorizationPersons());
        this.upDateTableData();
        this.dialogEncodeVisible = false;
        var names = [];
        var nameNews = [];
        result.data.forEach(obj => {
          names.push(obj.fileName);
          nameNews.push(obj.fileNameNew);
        });
        var user = encodeURI(header.user);
        var name = encodeURI(names.join("-*-"));
        var nameNew = encodeURI(nameNews.join("-*-"));
        this.loadingInstance.close();
        this.loadingInstance = Loading.service({
        text: "正在生成加密文件"
        });
        var url = baseUrl + "upload/GetFile?user=" + user + '&fileName=' + name + '&fileNameNew=' + nameNew;//指向webApi方法路径
        
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            this.download(url,user+"_"+new Date().getTime()+"_加密.zip");
          }
          else {            
            let link = document.createElement("a");
            document.body.appendChild(link);
            link.style.display='none';
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("click", false, false);
            link.href = url;
            link.dispatchEvent(evt);
            link.click();
            link.remove();           
          }          
        let load=this
        let timer = setInterval(function (){
            load.loadingInstance.close();
            clearInterval(timer);
            Message.success({
              duration:5000,
              message: "加密文件已保存"
          });            
        }, 5000);
        
      }
      if (this.encodeWay === "useTemplate") {
        if (!this.encodeSingleTable) {
          Message.error({
            message: "请选择加密模板"
          });
          return;
        }
        this.loadingInstance = Loading.service({
          text: "正在加密"
        });
        // 防止重复点击提交
        this.norClick = true;

        let requestData = {
          data: {
            templateid: this.encodeSingleTable.ID,
            path: this.uploadFiles.join("|"),
            pathnew: this.uploadFilesNew.join("|"),
            name: this.encodeSingleTable.Name
          }
        };
        let header = {
          user: this.userCn,
          responseType: "blob"
        };
        result = await encodeForTemplate(requestData, header);
        this.uploaderInit();
        this.uploadList(result.data, [this.encodeSingleTable.Name]);
        this.upDateTableData();
        this.dialogEncodeVisible = false;
        names = [];
        nameNews = [];
        result.data.forEach(obj => {
          names.push(obj.fileName);
          nameNews.push(obj.fileNameNew);
        });
        user = encodeURI(header.user);
        name = encodeURI(names.join("-*-"));
        nameNew = encodeURI(nameNews.join("-*-"));
        this.loadingInstance.close();
        this.loadingInstance = Loading.service({
        text: "正在生成加密文件"
        });
        
        let url = baseUrl + "upload/GetFile?user=" + user + '&fileName=' + name + '&fileNameNew=' + nameNew;//指向webApi方法路径
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            this.download(url,user+"_"+new Date().getTime()+"_加密.zip");          
          }
          else {
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.style.display='none'
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("click", false, false);
            link.href = url;
            link.dispatchEvent(evt);
            link.click();
            link.remove();            
          }
        let load=this
        let timer = setInterval(function (){
            load.loadingInstance.close();
            clearInterval(timer);
            Message.success({
              duration:3000,
              message: "加密文件已保存"
            });
        }, 5000);
      }
    },
    download(url,filename) {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true); // 也可以使用POST方式，根据接口
      xhr.responseType = "blob"; // 返回类型blob
      //xhr.setRequestHeader("Authorization",'BasicAuth ' + getStorage('ticket'))
      // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
      xhr.onload = function () {
        // 请求完成
        if (this.status === 200) {                   
          var csvData = new Blob([this.response], { type: 'text/csv;charset=utf-8' });
          window.navigator.msSaveOrOpenBlob(csvData, filename);          
        }
      };
      // 发送ajax请求
      xhr.send()
    },
    getFileName(namee){
      let namees=namee.split('.');
      if(namees[1]=="pdf"){
        return namees[0]+"_加密.ppdf";
      }else{
        return namees[0]+"_加密."+namees[1];
      }      
    },
    // 自定义加密参数格式化
    encodeForCustomData() {
      let data = {
        templateid: 0,
        Override: 1,
        path: "", // 文件名 | 隔开
        pathnew: "", // 文件名 | 隔开
        Displayname: "", // 登录的默认名称
        //OwnerEmail: "", // 登录的邮箱
        OwnerPhone: "", // KK联系 或电话
        Duration: "", // 到期时间 时间戳
        Copy: "",
        Print: "",
        ReadlyUsers: "", // 文档读者列表，取邮箱 | 号隔开
        WriteableUsers: "", //文档读者允许修改内容，取邮箱 | 号隔开
        name: ""
      };
      data.path = this.uploadFiles.join("|");
      data.pathnew = this.uploadFilesNew.join("|");
      data.Displayname = this.userName;
      //data.OwnerEmail = this.userEmail;
      data.OwnerPhone = this.setOwnerPhone();
      data.Duration = this.setDuration();
      data.Copy = this.allowCopy ? "1" : "0";
      data.Print = this.allowPrint ? "1" : "0";
      data.ReadlyUsers = this.setReadlyUsers();
      data.WriteableUsers = this.setWriteableUsers();
      data.name = this.getAuthorizationPersons().join(",");
      return data;
    },
    setDuration() {
      if (this.allowSetIndate) {
        return new Date(this.indate).getTime();
      } else {
        return "";
      }
    },
    setOwnerPhone() {
      let phone = "";
      if (this.allowContactAuthor) {
        switch (this.contactWay) {
          case "1":
            phone = "kk联系";
            break;
          case "2":
            phone = this.phone;
            break;
          default:
        }

        return phone;
      } else {
        return phone;
      }
    },
    setReadlyUsers() {
      let arr = [];
      this.persons.forEach(person => {
        if (person.customNode) {
          person.children.forEach(child => {
            arr.push(child.email);
          });
        } else {
          arr.push(person.email);
        }
      });

      return arr.join("|");
    },
    setWriteableUsers() {
      let arr = [];
      this.checkedPersons.forEach(person => {
        if (person.customNode) {
          person.children.forEach(child => {
            arr.push(child.email);
          });
        } else {
          arr.push(person.email);
        }
      });

      return arr.join("|");
    },
    // 自定义加密 弹框逻辑
    async loadNode(node, resolve) {
      let index = 0;      
      if(this.nodeIndex <= this.tabsCount -1) {
        index = this.nodeIndex;
        this.nodeIndex++;
      } else {
        index = this.tableIndex === this.tabsCount ? 0 : this.tableIndex;
      }
      
      if (node.level === 0) {
        let a = await this.loadDepartmentNode({ params: { index:index, id: "" } });        
        return resolve(a);
      } else {
        let b = await this.loadDepartmentNode({
          params: { index:index, id: node.data.path }
        });
        return resolve(b);
      }      
    },
    // 自定义加密 弹框逻辑
    async loadNode2(node, resolve) {
      if (node.level === 0) {
        let a = await this.loadDepartmentNode({ params: { index:0, id: "" } });
        return resolve(a);
      }
      if (node.level > 0) {
        let b = await this.loadDepartmentNode({
          params: { index:0, id: node.data.path }
        });
        return resolve(b);
      }
    },    
    handleCheckChange_companyStructrue(data, checked, indeterminate) {
      setTimeout(() => {
        let currtData = this.$refs[`companyStructrue${this.tableIndex}`][0].getCurrentNode();
        this.labelCheckedPerson = currtData;
      }, 100);
    },
    handleCheckChange_customStructrue(data, checked, indeterminate) {
      setTimeout(() => {
        let currtData = this.$refs.customStructrue.getCurrentNode();
        this.labelCheckedPerson = currtData;
      }, 100);
    },
    handleCheckChange_searchStructrue(data, checked, indeterminate) {
      setTimeout(() => {
        let currtData;
        if(this.tableIndex===this.tabsCount) {
          currtData = this.$refs.searchStructrue.getCurrentNode();
        }else {
          currtData = this.$refs[`searchStructrue${this.tableIndex}`][0].getCurrentNode();
        }
        this.labelCheckedPerson = currtData;
      }, 100);
    },
    handleCheckAllChange(isAllChecked) {
      this.checkedPersons = isAllChecked ? this.persons : [];
      this.isIndeterminate = false;
    },
    handleCheckedAllowChange(value) {
      let checkedCount = value.length;
      this.checkAllPersons = checkedCount>0 && checkedCount === this.persons.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.persons.length;
    },
    handleSearchData() {      
      this.getSearchDataInput();      
    },
    handleSearchDataKeyDown() {      
      this.getSearchDataKeyDown();      
    },    
    getSearchDataInput(){      
      if(this.searchId[this.tableIndex]==="") {
        this.searchData[this.tableIndex]=[];
        this.resultData[this.tableIndex]=[];
        this.tableDisabled=false;        
      }
    },
    async getSearchDataKeyDown() {   
      this.searchData[this.tableIndex]=[];
      this.resultData[this.tableIndex]=[];  
      this.tableDisabled=true;      
      this.emptyText="数据查询中";
      document.body.style.cursor ='wait';
      let res = await getSearchData({ params: { index: this.tableIndex, id: this.searchId[this.tableIndex] } });
      if(res.error){
        document.body.style.cursor='default';
        Message.error({
          message: res.error
        })
        return;
      }      

      for (let item of res) {
        let path = item.Path;
        let paths = path.split("_");
        let department = "";
        if (paths.length >= 2) department = path.split("_")[1];
        this.resultData[this.tableIndex].push({
          label: department!="" ? item.Name + "_" + department : item.Name,
          path: item.Path,
          typeId: item.TypeId,
          id: item.Id,
          parentId: item.ParentId,
          email: item.Email,
          department: department,
          customNode: false
        });
      }
      if(this.searchId[this.tableIndex]!="") {
        this.searchData[this.tableIndex] = this.resultData[this.tableIndex];
      } else {
        this.searchData[this.tableIndex] = [];
        this.resultData[this.tableIndex] = [];
      }
      document.body.style.cursor='default';
      this.tableDisabled=false;
      this.emptyText="暂无数据";
    },
    compare(prop) {
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }  
      } 
    },
    async loadEncodeTemplate() {
      let res = await getTemplates();
      let templates = res.Templates.Template;
      this.encodeTemplate = templates.sort(this.compare("Name"));
    },
    async loadCopyRightInfo() {
      let res= await getCopyRight({ params: { n:this.userCn } });
      let datalist=res.Table||[];
      if(datalist.length > 0 )
        this.IsShow=true
      else
        this.IsShow=false
    },
    async loadDepartmentNode(data) {
      let departmentNode = await getDepartmentNode(data);
      let result = [];
      let isLeaf = true;
      let department = "";
      for (let item of departmentNode) {
        isLeaf = item.TypeId === 2 ? true : false;
        department = item.Path.split("_")[1];

        result.push({
          label: item.Name,
          path: item.Path,
          typeId: item.TypeId,
          id: item.Id,
          parentId: item.ParentId,
          email: item.Email,
          leaf: isLeaf,
          department: department,
          customNode: false
        });
      }

      return result;
    },
    loadCustom() {
      this.customStructrueData = getStorage("group");
    },
    async loadDefaultOU(index) {
      this.defaultOU = await getDefaultOU();
    },
    async loadTabs() {      
      this.tabs = await getTabsName();
      this.tabsCount = this.tabs.length;
      for (let i = 0; i < this.tabsCount; i++) {
        this.searchId.push("");
      }
    },
    selectedFileReader(index) {
      if (this.activeClass === index) {
        this.activeClass = -1;
        this.selectedFileReaderIndex = -1;
        this.selectedFileReaderId = "";
      } else {
        this.activeClass = index;
        this.selectedFileReaderIndex = index;
        this.selectedFileReaderId = this.persons[index].id;
      }
    },
    addPerson() {
      // 组织架构人员添加到文档读者组，条件是不重复
      if (
        !include(this.persons, "id", this.labelCheckedPerson.id) &&
        this.labelCheckedPerson.label !== this.defaultOU[this.tableIndex]
      ) {
        this.persons.push(this.labelCheckedPerson);

        this.$nextTick(() => {
          this.handleCheckedAllowChange(this.checkedPersons);
        });
      }
    },
    deletePerson() {
      if (this.selectedFileReaderIndex >= 0) {
        this.persons.splice(this.selectedFileReaderIndex, 1);
        this.selectedFileReaderIndex = -1;
        this.activeClass = -1;

        for (let i = 0; i < this.checkedPersons.length; i++) {
          if (this.checkedPersons[i].id === this.selectedFileReaderId) {
            this.checkedPersons.splice(i, 1);
            break;
          }
        }
        this.$nextTick(() => {
          this.handleCheckedAllowChange(this.checkedPersons);
        });
      }
    },
    deletePersonWithDB(index) {
      this.persons.splice(index, 1);
      this.selectedFileReaderIndex = -1;
      this.activeClass = -1;

      for (let i = 0; i < this.checkedPersons.length; i++) {
        if (this.checkedPersons[i].id === this.selectedFileReaderId) {
          this.checkedPersons.splice(i, 1);
          break;
        }
      }
      this.$nextTick(() => {
        this.handleCheckedAllowChange(this.checkedPersons);
      });
    },
    handleSearchData2() {
      this.getSearchDataInput2();
    },
    handleSearchDataKeyDown2() {      
      this.getSearchDataKeyDown2();      
    },    
    getSearchDataInput2(){      
      if(this.searchId[this.tabsCount]==="") {
        this.searchData[this.tabsCount]=[];          
      }
    },
    async getSearchDataKeyDown2() {
      this.searchData[this.tabsCount]=[]; 
      this.emptyText2="数据查询中";
      document.body.style.cursor ='wait';
      let res = await getSearchData({
        params: { index:"0", id: this.searchIdForAddGroup }
      });
      let result = [];
      let department = "";

      for (let item of res) {
        department = item.Path.split("_")[1];
        result.push({
          label: item.Name + "_" + department,
          path: item.Path,
          typeId: item.TypeId,
          id: item.Id,
          parentId: item.ParentId,
          email: item.Email,
          department: department,
          customNode: false
        });
      }
      this.searchData[this.tabsCount] = result;
      document.body.style.cursor='default';      
      this.emptyText2="暂无数据";
    },
    // 添加组 弹框逻辑
    handleCheckChangeForGroup(data, checked, indeterminate) {
      setTimeout(() => {
        let currtData = this.$refs.newGroupTreeSource.getCurrentNode();
        this.labelCheckedPerson = currtData;
      }, 100);
    },
    handleSelectionChange(val) {
      this.singleSelection = val;
    },
    addPersonToGroup() {
      if (
        !include(this.newGroupData, "id", this.labelCheckedPerson.id) &&
        this.labelCheckedPerson !== this.defaultOU[this.tableIndex]
      ) {
        this.newGroupData.push(this.labelCheckedPerson);
      }
    },
    deletePersonFromGroup() {
      let singleSelectionId = this.singleSelection.id || "";
      let index = indexWith(this.newGroupData, "id", singleSelectionId);
      if (include(this.newGroupData, "id", singleSelectionId)) {
        this.newGroupData.splice(index, 1);
      }
    },
    createGroup() {
      this.dialogText = "添加自定义人员组";
      this.dialogPersonVisible = true;
      this.createOrEdit = "create";
    },
    editGroup() {
      let currtData = this.$refs.customStructrue.getCurrentNode();

      if (currtData.customNode === true) {
        this.labelCheckedPerson = currtData;
        this.dialogText = "更改自定义人员组";
        this.dialogPersonVisible = true;
        this.createOrEdit = "edit";

        this.groupName = currtData.label;
        this.newGroupData = currtData.children;
      } else {
        Message.error({
          message: "无法直接更新组内成员，请选择人员组根节点"
        });
      }
    },
    deleteGroup() {
      let flag;
      let group = getStorage("group");
      let currtData = this.$refs.customStructrue.getCurrentNode();

      if (currtData.customNode === true) {
        group.forEach((item, index) => {
          if (item.id === currtData.id) {
            flag = index;
          }
        });
        group.splice(flag, 1);
        setStorage("group", group);
      } else {
        Message.error({
          message: "无法直接删除组内成员，请选择人员组根节点"
        });
      }
      this.loadCustom();
      this.initGroup();      
    },
    handleGroup() {
      let group = getStorage("group") || [];
      let temp;
      let tempData;
      let tempIndex;
      if (!this.newGroupData.length) {
        Message.error({
          message: `请选择人员`
        });
        return;
      }
      if (!this.groupName) {
        Message.error({
          message: `请填写自定义组名`
        });
        return;
      }

      if (this.createOrEdit === "create") {
        group.push(this.createGroupNode());
        setStorage("group", group);
        Message.success({
          message: `添加成功`
        });
      } else if (this.createOrEdit === "edit") {
        temp = this.editGroupNode();
        tempData = temp[0];
        tempIndex = temp[1];
        group.splice(tempIndex, 1, tempData);
        setStorage("group", group);
        Message.success({
          message: `更改成功`
        });
      }
      this.dialogPersonVisible = false;
      this.loadCustom();
      this.initGroup();
    },
    createGroupNode() {
      let result = {};
      result.id = new Date().getTime();
      result.customNode = true;
      result.label = this.groupName;
      result.children = this.newGroupData;
      result.path = this.groupName;

      return result;
    },
    editGroupNode() {
      let result;
      let flag;
      let group = getStorage("group");
      let currtData = this.$refs.customStructrue.getCurrentNode();
      group.forEach((item, index) => {
        if (item.id === currtData.id) {
          result = Object.assign({}, item);
          flag = index;
        }
      });
      result.children = this.newGroupData;

      return [result, flag];
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    deleteGroupPerson(row) {
      this.newGroupData.splice(row.index, 1);
    },
    handlePersonClose() {
      this.dialogPersonVisible = false;
      this.initGroup();
    },
    initGroup() {
      // 初始化输入框和选择框
      this.groupName = "";
      this.newGroupData = [];
    },
    initEncode() {
      // 模板加密
      this.labelCheckedPerson = "";
      // 自定义加密
      this.encodeSingleTable = "";
      this.highlight = false;
      this.labelCheckedPerson = "";
      this.persons = [];
      this.allowPrint = false;
      this.allowCopy = false;
      this.allowSetIndate = false;
      this.allowContactAuthor = false;
      this.phone = "";
      this.checkAllPersons = false;
      this.searchIdForAddGroup = "";     

      //初始化弹框
      this.resetComponent = false;
      this.$nextTick(() => {
        this.tableIndex = 0;
        this.resetComponent = true;
      });

      // 防止重复发送加密请求
      this.norClick = false;
    }
  },
  destroyed () {
    if (this.timer) { 
      clearInterval(this.timer)
    }   
  }
};
</script>
<style lang="scss">
@import "../common/theme/myTheme.scss";

// 单独更改树形控件高亮颜色
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: rgb(218, 218, 218);
}
.el-tree-node.is-current > .el-tree-node__content {
  background: rgb(218, 218, 218);
}

.help {
  img {
    vertical-align: bottom;
  }
}
.login {
  img {
    vertical-align: bottom;
  }
}
main {
  //padding: 10px;
  background-color: rgb(247, 248, 251);
  .table-container {
    padding: 10px;
    background-color: #fff;
    .title {
      font-size: 20px;
      margin-bottom: 20px;
    }
    .operation {
      margin: 10px 0 0 0;
      text-align: center;
      .select-file {
        padding: 12px 18px;
        border: none;
        outline: none;
        border-radius: 4px;
        background: $skyBlue;
        color: #fff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

.encode-dialog-container {
  .encode-way {
    margin-bottom: 20px;
  }
  .panel {
    .use-template {
      .el-table__body tr.current-row > td {
        background: #dadada;
      }
      .use-template-foot {
        margin-top: 20px;
      }
    }
    .use-custom {
      .custom-way-container {
        font-size: 14px;
        .company-structure {
          width: 380px;
          height: 400px;
          .content {
            width: 348px;
            height: 320px;
            overflow: auto;
            .el-tree-node > .el-tree-node__children {
              overflow: visible;
            }
            .search {
              margin-bottom: 15px;
            }
            .custom-list {
              height: 280px;
              overflow-y: scroll;
            }
            .custom-operation {
              margin-top: 5px;
            }
          }
        }
        .add-person {
          width: 100px;
          height: 390px;
          position: relative;
          .content {
            width: 20px;
            height: 100px;
            position: absolute;
            top: 150px;
            left: 35px;
            div {
              width: 30px;
              height: 26px;
              color: #fff;
              border-radius: 4px;
              background-color: $skyBlue;
              margin: 20px 0;
              position: relative;
              &:hover {
                cursor: pointer;
              }
              i {
                position: absolute;
                width: 14px;
                height: 14px;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
              }
            }
          }
        }
        .permission {
          border: 1px solid #ccc;
          box-shadow: 0px 2px 3px #ccc;
          height: 390px;
          width: 420px;
          .title {
            height: 39px;
            background-color: #f5f7fa;
            border-bottom: 1px solid #ccc;
            & > span {
              padding: 10px;
            }
            .ellipsis {
              padding-right: 27px;
            }
          }
          .content {
            height: 350px;
            overflow: auto;
            .person {
              padding: 10px;
              .name {
                max-width: 220px;
                .name-path {
                  max-width: 200px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
                &:hover {
                  cursor: pointer;
                }
              }
            }
            .active {
              background: #dadada;
            }
          }
        }
        .quanxian {
          margin-top: 15px;
          .contact {
            margin: 15px 0;
            input {
              width: 220px;
              height: 28px;
              line-height: 30px;
              border: 1px solid #ccc;
              border-radius: 5px;
              padding-left: 5px;
            }
          }
        }
      }
    }
  }
}

.person-dialog-container {
  .company-structure {
    margin-bottom: 10px;
    .search {
      margin-bottom: 10px;
      .input {
        width: 300px;
        padding: 4px;
      }
    }
    .content {
      width: 407px;
      height: 420px;
      border: 1px solid #dcdfe6;
      overflow: auto;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      .el-tree-node > .el-tree-node__children {
        overflow: visible;
      }
    }
  }
  .add-person {
    width: 100px;
    height: 450px;
    position: relative;
    .content {
      width: 20px;
      height: 100px;
      position: absolute;
      top: 170px;
      left: 38px;
      div {
        width: 30px;
        height: 26px;
        color: #fff;
        border-radius: 4px;
        background-color: $skyBlue;
        margin: 20px 0;
        position: relative;
        &:hover {
          cursor: pointer;
        }
        i {
          position: absolute;
          width: 14px;
          height: 14px;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
  .group {
    margin-bottom: 10px;
    .group-name {
      margin-bottom: 10px;
      input {
        margin: 4px 0;
        width: 300px;
        padding: 4px;
        height: 32px;
        line-height: 32px;
      }      
    }
    .content {
      height: 420px;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      .el-table tbody tr.current-row > td {
        background: #dadada;
      }
    }
  }
  .operation {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/homepage.vue